import { Component, OnInit, OnChanges, SimpleChanges, EventEmitter, Input, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { CookiesService } from 'src/app/CookieService';
import { FAVOURITES_COOKIE_EXPIRY_DAYS, FAVOURITES_COOKIE_NAME, FAVOURITES_COOKIE_SEPARATOR } from 'src/app/models/app-constants';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DIALOG_RESULT, YesNoDialogComponent } from '../yes-no-dialog/yes-no-dialog.component';
import { Subscription } from 'rxjs';
import { UserFeedbackModalDialogComponent } from '../custom-modal-dialog/user-feedback-modal-dialog/user-feedback-modal-dialog.component';

export type FavouriteIconClickedEvent = { siteIdentifier: string; isFavourite: boolean };

@Component({
	// standalone: true,
	selector: 'app-favourite-icon',
	templateUrl: './favourite-icon.component.html',
	styleUrls: ['./favourite-icon.component.scss']	
})
export class FavouriteIconComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
	@Input() showLabel: boolean = false;
	@Input() siteName : string = "";
	@Input() siteIdentifier: string;	
	@Input() unselectedIcon : string = "favourites-unselected.svg";
	@Output() favouriteIconClickedEvent: EventEmitter<FavouriteIconClickedEvent> = new EventEmitter<FavouriteIconClickedEvent>();

	isFavourite: boolean = false;
	private yesNoDialogSub : Subscription;

	public dialogData : any = null;
	public showDialog : boolean = false;	

	constructor(private cookieService: CookiesService,
		private yesNoDialog : MatDialog,
		private userfeedbackModalDlg : UserFeedbackModalDialogComponent) 
	{

	}

	ngOnInit(): void {
		
	}


	ngOnChanges(changes: SimpleChanges): void {
		if (changes["siteIdentifier"] && this.siteIdentifier) {
			const favourites = this.cookieService.getCookie(FAVOURITES_COOKIE_NAME)?.split(FAVOURITES_COOKIE_SEPARATOR).filter(Boolean) || [];
			if (Array.isArray(favourites)) {
				this.isFavourite = -1 < favourites.indexOf(this.siteIdentifier);
			}
		}
	}

	ngAfterViewInit(): void {

	}

	ngOnDestroy(): void {
		this.yesNoDialogSub && this.yesNoDialogSub.unsubscribe();
	}

	private removeFromFavourites = () => {
		this.hideFeedbackDialog();
		const favourites = this.cookieService.getCookie(FAVOURITES_COOKIE_NAME)?.split(FAVOURITES_COOKIE_SEPARATOR).filter(Boolean) || [];
		const index = favourites.indexOf(this.siteIdentifier);
		if (-1 < index) 
		{			
			favourites.splice(index, 1);
			this.updateCookies(favourites);
		}
	}

	private updateCookies = (favourites : string[]) => {
		const cookies = favourites.filter(Boolean).join(FAVOURITES_COOKIE_SEPARATOR);
		this.cookieService.setCookie(FAVOURITES_COOKIE_NAME, cookies, FAVOURITES_COOKIE_EXPIRY_DAYS);
		this.isFavourite = -1 < favourites.indexOf(this.siteIdentifier);
		this.favouriteIconClickedEvent.emit({ siteIdentifier: this.siteIdentifier, isFavourite: this.isFavourite });
	}

	private displayConfirmDialog = () => {
		const title =  "Remove from favourites";
		const content = "Do you want to remove " + (this.siteName ? `'${this.siteName}' ` : "") + "from favourites?";

		this.dialogData = {
			data : 
			{ 
				title : title,
				content : content,
				acceptButtonText : "Yes",
				cancelButtonText : "No",
				showCancelButton : true,
				acceptClicked : this.removeFromFavourites,
				cancelClicked : this.hideFeedbackDialog
		}}
		//this.showDialog = true;
		this.userfeedbackModalDlg?.openDialog(this.dialogData);
	}

	toggleFavourite = (event: any) => {
		const favourites = this.cookieService.getCookie(FAVOURITES_COOKIE_NAME)?.split(FAVOURITES_COOKIE_SEPARATOR).filter(Boolean) || [];
		const index = favourites.indexOf(this.siteIdentifier);

		if (-1 < index) 
		{	
			//favourites.splice(index, 1);	
			this.displayConfirmDialog();			
		}
		else 
		{
			favourites.push(this.siteIdentifier);			
			this.updateCookies(favourites);
		}		
	}

	onAcceptRemoveFavourite = (event : any) => {
		console.log("removed from favourites");
	}

	onRejectRemoveFavourite = (event : any) => {
		console.log("not removed from favourites");
	}

	onKeyPress = (event : KeyboardEvent) => 
	{
		if("Enter" === event.key)
		{
			this.toggleFavourite(event);
		}
	}	

	private hideFeedbackDialog = () => {	
		this.showDialog = false;
		this.dialogData = null;		
	}	
}
